import { CRMAPIBase } from '@api/crmApiBase';
import { NotificationListResp } from '@api/responseModels/notification/notificationListResp';
import { NotificationResp } from '@api/responseModels/notification/notificationResp';

class NotificationGroup extends CRMAPIBase {
    /**
     * Получение списка уведомлений
     * @param crm_id ID CRM
     * @param profile_type Тип профиля пользователя
     * @param profile_id ID профиля пользователя
     * @param sort_by Сортировка по
     * @param sort_direction Направление сортировки
     * @param query Поисковый запрос
     * @param page Страница
     * @param per_page Элементов на страницу
     * @returns Список уведомлений
     */
    async getNotificationList(params: {
        crm_id: number;
        profile_type: 'worker' | 'customer';
        profile_id: number;
        sort_by?: 'reciever' | 'sender' | 'created_at' | 'updated_at';
        sort_direction?: 'asc' | 'desc';
        query?: string;
        page?: number;
        per_page?: number;
    }) {
        const result = await this.get<NotificationListResp>('notifications', params);

        return result;
    }

    /**
     * Получение отдельного уведомления
     * @param crmId ID CRM
     * @param notificationId ID уведомления
     * @returns Найденное уведомление
     */
    async getNotification(crmId: number, notificationId: string) {
        const result = await this.get<NotificationResp>(`notifications/${notificationId}`, {
            crm_id: crmId,
        });
        return result;
    }

    /**
     * Отметить уведомление как прочитанное
     * @param crmId ID CRM
     * @param notificationId ID уведомления
     * @returns Обновленное уведомление
     */
    async markNotificationAsRead(crmId: number, notificationId: string) {
        return;
    }
}

export { NotificationGroup };
